import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { ExampleMeta } from "../types/routecore";

// Carrega a lista de exemplos uma única vez por monta. Os componentes
// que precisam dessa lista (sidebar de examples, dropdown de payload)
// reutilizam o resultado sem re-fetch.
export function useExamples() {
  const [examples, setExamples] = useState<ExampleMeta[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .listExamples()
      .then((r) => {
        if (cancelled) return;
        if (!r.ok || !r.data) {
          setError("não foi possível listar exemplos");
          setExamples([]);
        } else {
          setExamples(r.data.examples);
        }
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : String(err));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { examples, loading, error };
}
